import { render, staticRenderFns } from "./UserEditView.vue?vue&type=template&id=87960724"
import script from "./UserEditView.vue?vue&type=script&lang=js"
export * from "./UserEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports